import React from 'react';
import { TypeLiquidation } from '../coinLiquidation/types';
import { SupportedNetWork } from '../coinLiquidation/constants';

interface SellAllButtonProps {
  tokensCount: number;
  walletTotalTokens: number;
  isLoading: boolean;
  refreshingTokens: boolean;
  typeLiquidation: TypeLiquidation;
  hasAtLeastOneChosenCoin: boolean;
  onSellAll: () => void;
}

export const SellAllButton: React.FC<SellAllButtonProps> = ({
  tokensCount,
  walletTotalTokens,
  isLoading,
  refreshingTokens,
  typeLiquidation,
  hasAtLeastOneChosenCoin,
  onSellAll,
}) => {
  if (tokensCount === 0 && walletTotalTokens === 0) {
    return null;
  }

  return (
    <div className="text-center px-2">
      <button
        onClick={onSellAll}
        disabled={isLoading || refreshingTokens || (typeLiquidation === TypeLiquidation.CUSTOM && !hasAtLeastOneChosenCoin)}
        className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-3.5 bg-red-600 hover:bg-red-700 active:bg-red-800 disabled:bg-gray-600 disabled:cursor-not-allowed rounded-lg text-sm  md:text-lg font-medium min-h-[56px] sm:min-h-[52px] transition-colors"
      >
        {isLoading ? (
          <span className="hidden sm:inline">Selling...</span>
        ) : refreshingTokens ? (
          <span className="hidden sm:inline">Updating balances...</span>
        ) : (
          <>
            <span className="hidden sm:inline">Sell All Selected Tokens ({tokensCount})</span>
            <span className="sm:hidden">Sell All ({tokensCount})</span>
          </>
        )}
      </button>
      <p className="text-xs sm:text-sm text-gray-400 mt-2 px-2">
        {walletTotalTokens > 0
          ? `Found ${walletTotalTokens} tokens across ${SupportedNetWork.length} chains`
          : 'No tokens found in wallet'
        }
      </p>
    </div>
  );
};

